<template>
    <div :class="['header', { 'header-scrolled': isScrolled }]">
        <!-- 顶部信息栏容器 -->
        <div class="top-bar">
            <!-- 左侧联系方式区（红色背景） -->
            <div class="d-f">
                <div class="top-bar-left">
                    <span class="top-bar-contact">
                        <img src="../../assets/imgs/dianhua.png" alt="">(+61) 02 8079 7000
                    </span>
                    <span class="top-bar-contact">
                        <img src="../../assets/imgs/youxiang.png" alt="">contact@newlegend.com.au
                    </span>
                </div>
                <!-- 右侧营业时间区（黑色背景） -->
                <div class="top-bar-right">
                    <span class="top-bar-hours">
                        <img src="../../assets/imgs/zhongbiao.png" alt="">Mon - Fri: 9:00am - 5:30pm
                    </span>
                    <span class="top-bar-chat"><i class="icon-chat"></i>
                    </span>
                </div>
            </div>
        </div>
        <nav class="navbar">
            <p class="navbar-brand cup" @click="toPageFn('/zh/index')">
                <img class="logo" src="../../assets/imgs/logo.png" alt="">
            </p>
            <div class="navbar-collapse" id="navbarNav">
                <i class="el-icon-menu icon" @click="showMenu = true"></i>
                <ul class="navbar-nav">
                    <li class="nav-item" v-for="(item, index) in navList"
                        :class="activePath == item.nav_id ? 'active' : ''" @click="toPageFn(item, index)">
                        <p class="nav-item-title">
                            {{ item.nav_title }}
                            <i class="el-icon-arrow-down" v-if="item.children2 && item.children2.length > 0"></i>
                        </p>
                        <template v-if="item.children2 && item.children2.length > 0">
                            <ul class="nav-item-children">
                                <li v-for="(child, childIndex) in item.children2" class="nav-item-children-item"
                                    @click.stop="toPageFn(item, childIndex, child)">
                                    <p class="nav-item-children-item-title">
                                        {{ child.nav_title }}
                                    </p>
                                </li>
                            </ul>
                        </template>
                    </li>
                </ul>
                <div class="h5-bg" v-if="showMenu">
                    <ul class="h5-nav">
                        <p class="h5-title">
                            <span>菜单</span>
                            <i class="el-icon-close" @click="showMenu = false"></i>
                        </p>
                        <li class="h5-item" v-for="(item, index) in navList"
                            :class="activePath == item.nav_id ? 'active' : ''" @click="toPageFn(item, index)">
                            <p class="h5-item-title">
                                {{ item.nav_title }}
                                <i class="el-icon-arrow-right" v-if="item.children2 && item.children2.length > 0"></i>
                            </p>
                            <template v-if="item.children2 && item.children2.length > 0">
                                <ul class="h5-item-children">
                                    <li v-for="(child, childIndex) in item.children2" class="h5-item-children-item"
                                        @click.stop="toPageFn(item, childIndex, child)">
                                        <p class="h5-item-children-item-title">
                                            {{ child.nav_title }}
                                        </p>
                                    </li>
                                </ul>
                            </template>
                        </li>
                    </ul>
                </div>
                <div class="lang" @click="changeLangFn">en</div>
            </div>
        </nav>
    </div>
</template>
<script>
export default {
    data() {
        return {
            lang: 'en',
            isScrolled: false,
            scrollHandler: null,
            activePath: this.$route.nav_id || '/zh/index',
            navList: [],
            showMenu: false
        }
    },
    mounted() {
        // 页面挂载后监听滚动事件（防抖优化，避免频繁触发）
        this.scrollHandler = this.debounce(() => {
            // 滚动距离超过50px时，设置为悬浮状态
            this.isScrolled = window.scrollY > 50;
        }, 10); // 10ms防抖，兼顾性能和体验

        window.addEventListener('scroll', this.scrollHandler);

        this.getNavList()
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.scrollHandler);
    },
    watch: {
        // 监听路由参数nav_id 
        '$route.query.nav_id': {
            handler(newVal) {
                this.activePath = newVal
            },
            immediate: true
        }

    },
    methods: {
        closeFn() { },
        getNavList() {
            this.$http.nav_list().then(res => {
                console.log(res)
                this.navList = res.data
                localStorage.setItem('nav_list', JSON.stringify(res.data))
            })
        },
        debounce(fn, delay) {
            let timer = null;
            return function () {
                clearTimeout(timer);
                timer = setTimeout(() => {
                    fn.apply(this, arguments);
                }, delay);
            };
        },
        changeLangFn() {
            let path = this.$route.fullPath;
            path = path.replace('/zh/', '/en/')
            localStorage.setItem('lang', 'en')
            this.$router.push(path);

        },
        toPageFn(item, childIndex, child) {
            if (child) {
                if (child.model_id == 1 && child.url) {
                    window.open(child.url, '_blank')
                    return
                }
            }
            if (item.nav_title == '首页') {
                this.$router.push('/zh/index')
                this.showMenu = false
            } else if (item.nav_title == '联系我们' || item.nav_title == '关于我们') {
                this.$router.push('/zh/contactUs?currentNav=' + childIndex)
                this.showMenu = false
                console.log(childIndex)
            } else if (item.nav_title == '成功案例' || item.nav_title == '下签喜报') {
                this.$router.push('/zh/goodNews?nav_id=' + item.nav_id + "&currentNav=" + childIndex)
                this.showMenu = false
            } else if (item.nav_title == '新闻中心') {
                this.$router.push('/zh/news')
                this.showMenu = false
            } else {
                if (item.model_type_id == 854) {
                    this.$router.push('/zh/goodNews?nav_id=' + item.nav_id + "&currentNav=" + childIndex)
                    this.showMenu = false
                } else {
                    if (childIndex) {
                        this.$router.push('/zh/immigration?nav_id=' + item.nav_id + "&currentNav=" + childIndex)
                        this.showMenu = false
                    } else {
                        this.$router.push('/zh/immigration?nav_id=' + item.nav_id)
                    }
                    if (item.children2 && item.children2.length > 0) {
                    } else {
                        this.showMenu = false
                    }
                }
            }
            localStorage.setItem('nav_item', JSON.stringify(item))
        }
    }
}
</script>
<style lang="less" scoped>
// 深黑 333333
// 浅黑 c4cad6
// 按钮 2e7af2


.header {
    height: 140px;
    position: relative;

    /* 顶部栏整体样式：相对定位，作为倾斜区域的容器 */
    .top-bar {
        position: relative;
        width: 100%;
        height: 40px;
        color: #fff;
        font-size: 15px;
        overflow: hidden;
        background-color: #333333;

        .top-bar-left {
            position: absolute;
            top: 0;
            left: 0;
            width: 70%;
            height: 100%;
            background-color: #f1f1f1;
            transform: skewX(-25deg);
            transform-origin: top left;
            padding-left: 40px;
            display: flex;
            align-items: center;
            gap: 25px;
        }

        .top-bar-left .top-bar-contact {
            transform: skewX(25deg);
            color: #000;
            text-decoration: none;
            display: flex;
            align-items: center;
            gap: 5px;
        }

        i {
            transform: skewX(25deg);
            margin-right: 3px;
        }

        .top-bar-right {
            position: absolute;
            top: 0;
            right: 0;
            width: 55%;
            height: 100%;
            background-color: #333;
            transform: skewX(-25deg);
            transform-origin: top right;
            padding-right: 40px;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            gap: 25px;
        }

        .top-bar-right .top-bar-hours,
        .top-bar-right .top-bar-chat {
            transform: skewX(25deg);
            display: flex;
            align-items: center;
            gap: 5px;
        }

        .top-bar-contact:hover {
            text-decoration: underline;
        }

        img {
            width: 20px;
            // 滤镜改成图片为黑色
            filter: invert(100%);
        }

        /* 响应式适配：移动端调整倾斜角度和间距 */
        @media (max-width: 768px) {
            .top-bar {
                height: auto;
                padding: 10px 0;
            }

            .top-bar-left,
            .top-bar-right {
                position: relative;
                width: 100%;
                transform: skewX(0);
                padding: 10px 20px;
                justify-content: center;
                box-sizing: border-box;
            }

            .top-bar-left .top-bar-contact,
            .top-bar-right .top-bar-hours,
            .top-bar-right .top-bar-chat {
                transform: skewX(0);
                font-size: 13px;
            }

            .top-bar-left {
                margin-bottom: 10px;
                gap: 15px;
            }

            .top-bar-right {
                gap: 15px;
            }

            img {
                width: 16px;
            }
        }

        /* 响应式适配：小屏幕设备 */
        @media (max-width: 480px) {
            .top-bar-left {
                flex-direction: column;
                gap: 5px;
                padding: 10px;
            }

            .top-bar-right {
                flex-direction: column;
                gap: 5px;
                padding: 10px;
            }

            .top-bar-left .top-bar-contact,
            .top-bar-right .top-bar-hours,
            .top-bar-right .top-bar-chat {
                font-size: 12px;
            }
        }

    }

}

.header-scrolled {
    position: fixed;
    top: -120px;
    left: 0px;
    width: 100%;
    height: 120px;
    transform: translateY(120px);
    box-shadow: rgba(0, 0, 0, 0.05) 0px 20px 40px;
    background: #fff;
    z-index: 999;
    transition: transform 0.5s, -webkit-transform 0.5s;

    .navbar {
        background: #fff;

        .navbar-collapse .nav-item {
            color: #333333;
        }
    }
}

.navbar {
    // position: fixed;
    display: flex;
    width: 100vw;
    justify-content: space-between;
    padding: 0 40px 0 20px;
    box-sizing: border-box;
    align-items: center;
    z-index: 99;
    height: 100px;
    background-color: #fff;
    border-bottom: 1px solid #333333a1;

    .navbar-brand {
        width: 200px;
        flex-shrink: 0;
        height: 120px;
        margin: 0;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;

        .logo {
            height: 80px;
            width: auto;
        }
    }

    .navbar-collapse {
        display: flex;
        align-items: center;
        flex: 1;
        justify-content: space-around;

        .icon {
            display: none;
        }

        .lang {
            margin-left: 40px;
            background-color: #333333;
            color: #fff;
            padding: 3px 10px;
            min-width: 60px;
            text-align: center;
            box-sizing: border-box;
            border-radius: 4px;
            font-size: 14px;
            flex-shrink: 0;
            cursor: pointer;
        }

        .navbar-nav {
            list-style: none;
            display: flex;
            flex-wrap: wrap;
            align-items: center;
        }

        .nav-item {
            cursor: pointer;
            margin-left: 10px;
            color: #333333;
            position: relative;
            // height: 50px;
            transition: .5s;
            min-height: 35px;
            display: flex;
            align-items: center;
            justify-content: center;

            .nav-item-title {
                position: relative;
                z-index: 2;
                transition: all 0.5s;
                height: 100%;
                padding: 0 10px;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .nav-item-children {
                position: absolute;
                top: 100%;
                z-index: 99;
                padding: 10px;
                width: auto;
                left: 0;
                background-color: #fff;
                list-style: none;
                white-space: nowrap;
                transition: .3s all;
                transform: scale(0);

                li {
                    padding: 0 10px;
                    box-sizing: border-box;
                    height: 40px;
                    display: flex;
                    align-items: center;
                    border-bottom: 1px solid #8a6b14e6;
                }

                li:hover,
                .active {
                    color: #333333;
                    background-color: #9b9da01f
                }

                li:nth-last-of-type(1) {
                    border-bottom: none;
                }
            }
        }

        .nav-item:hover .nav-item-children {
            transform: scale(1);
        }

        .nav-item:after,
        .nav-item::before {
            position: absolute;
            content: "";
            top: 30px;
            bottom: 30px;
            left: 0px;
            width: 100%;
            height: 2px;
            background: #9b9da0;
            opacity: 0;
            transition: all 0.5s;
        }

        .nav-item:before {
            bottom: 25px;
            opacity: 0;
        }

        .nav-item:after {
            top: 25px;
            opacity: 0;
        }

        .nav-item:hover:before,
        .nav-item.active:before {
            top: 0;
            opacity: 1;
        }

        .nav-item:hover::after,
        .nav-item.active::after {
            top: 100%;
            opacity: 1;
        }

        .nav-item:hover .nav-item-title::after,
        .nav-item.active .nav-item-title::after {
            position: absolute;
            left: 0;
            width: 100%;
            height: 100%;
            content: "";
            z-index: 0;
            transition: all 0.5s;
        }

        .nav-item.active .nav-item-title {
            font-weight: 500;
        }

        .nav-item .nav-item-title::after {
            background-color: #5758581f;
            position: absolute;
            left: 0;
            width: 100%;
            height: 0%;
            content: "";
            z-index: 0;
            transition: all 0.5s;
        }
    }
}

.h5-bg {

    display: none;
}

/* 当屏幕宽度小于600px时 */
@media (max-width: 900px) {
    .header {

        .top-bar {
            display: block;
            height: auto;
            padding: 10px 0;

            img {
                width: 15px;
            }

            .top-bar-left {
                margin-bottom: 10px;
                width: 100%;
                box-sizing: border-box;
                justify-content: center;
                gap: 15px;
            }

            .top-bar-left .top-bar-contact {
                font-size: 12px;
            }

            .top-bar-right {
                position: relative;
                height: auto;
                line-height: normal;
                padding: 10px 20px;
                justify-content: center;
                gap: 15px;
            }
        }
    }

    .navbar {
        padding: 0 20px;
        height: 70px;

        .navbar-brand {
            height: 40px;
            width: auto;
            flex-shrink: 0;

            .logo {
                height: 60px;
                width: auto;
            }
        }

        .navbar-collapse .icon {
            display: block;
            font-size: 24px;
        }

        .navbar-collapse .navbar-nav {
            display: none;
        }

        .h5-bg {
            position: fixed;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;
            display: block;
            background-color: #141313b6;
            z-index: 999999;
        }

        .h5-nav {
            width: 80%;
            max-width: 300px;
            background-color: #fff;
            height: 100vh;
            overflow-y: auto;

            .h5-title {
                height: 50px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 0 15px;
                font-size: 18px;
                box-sizing: border-box;
                border-bottom: 1px solid #ececec;
            }

            .h5-item-title {
                height: 45px;
                border-bottom: 1px solid #ececec;
                font-size: 14px;
                padding: 0 15px;
                box-sizing: border-box;
                line-height: 45px;
                color: #333;
                display: flex;
                justify-content: space-between;
                align-items: center;
            }

            .h5-item-children {
                display: none;
            }

            .h5-item.active .h5-item-children {
                display: block;
                font-size: 13px;
                padding: 5px 0;
                color: #444;
                background-color: #f1f1f1;
                border-bottom: 1px solid #ececec;
                border-top: 1px solid #ececec;
            }

            .h5-item-children-item-title {
                padding-left: 25px;
                line-height: 35px;
                border-bottom: 1px solid #e0e0e0;
            }

            .h5-item-children-item-title:last-child {
                border-bottom: none;
            }

            .active .el-icon-arrow-right {
                transform: rotateZ(90deg);
                transition: transform 0.3s ease;
            }
        }
    }

}

/* 响应式适配：小屏幕设备 */
@media (max-width: 480px) {
    .navbar {
        padding: 0 15px;
        height: 60px;

        .navbar-brand {
            height: 30px;

            .logo {
                height: 50px;
            }
        }

        .h5-nav {
            width: 90%;
        }
    }

    .header-scrolled {
        height: 100px;
        top: -100px;
        transform: translateY(100px);
    }
}

</style>
<style lang="less">
.el-menu,
.el-menu.el-menu--horizontal {
    background-color: transparent;
    border-bottom: 0;

}

.el-menu-item,
.el-submenu__title,
.el-menu--horizontal>.el-menu-item,
.el-menu--horizontal>.el-submenu .el-submenu__title {
    font-size: 17px;
    color: #7e3603;
}

.el-menu--horizontal .el-menu .el-menu-item,
.el-menu--horizontal .el-menu .el-submenu__title {
    font-size: 16px;
}

.el-menu--horizontal>.el-menu-item.is-active,
.el-menu--horizontal>.el-submenu.is-active .el-submenu__title {

    border-bottom: 2px solid #333333;
    color: #333333;
    background-color: #feefd4;
}

.el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal .el-menu-item:not(.is-disabled):hover,
.el-menu--horizontal>.el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal>.el-menu-item:not(.is-disabled):hover,
.el-menu--horizontal>.el-submenu .el-submenu__title:hover {
    color: #333333;
    background-color: #feefd4;
}

.el-menu--horizontal .el-menu .el-menu-item {
    color: #9a4203;
}
</style>


// WEBPACK FOOTER //
// src/components/zh/header.vue